@if (viewMode === ViewModes.Grid) {
<div
  infiniteScroll
  [infiniteScrollDistance]="5"
  [infiniteScrollThrottle]="50"
  [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty || isCachedLastPage"
  (scrolled)="scrollPage(model?.pagination?.currentPage + 1)"
>
  <div class="row">
    @for (product of productListResults; track product) {
    <app-product-grid-item [product]="product" [basepriceHidden]="basepriceBehavior"></app-product-grid-item>
    }
  </div>
  <div
    [className]="
      !isLastPage && model?.pagination?.currentPage > 0
        ? 'cx-double-btn-container grid-btn-padding'
        : 'cx-single-btn-container grid-btn-padding'
    "
  >
    @if (isMaxProducts && !isLastPage) {
    <div (click)="loadNextPage(model?.pagination?.currentPage + 1)" class="btn btn-block btn-action align-btn">
      {{ 'productList.showMoreBtn' | cxTranslate }}
    </div>
    }
  </div>
  @if (appendProducts) {
  <div class="cx-spinner">
    <!--      <cx-spinner></cx-spinner>-->
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
  }
</div>
} @if (viewMode === ViewModes.List) {
<div
  infiniteScroll
  [infiniteScrollDistance]="3"
  [infiniteScrollThrottle]="50"
  [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty || isCachedLastPage"
  (scrolled)="scrollPage(model?.pagination?.currentPage + 1)"
>
  @for (product of productListResults; track product) {
  <app-product-list-item
    [product]="product"
    [basepriceHidden]="basepriceBehavior"
    class="cx-product-search-list"
  ></app-product-list-item>
  }
  <div
    [className]="
      !isLastPage && model?.pagination?.currentPage > 0 ? 'cx-double-btn-container' : 'cx-single-btn-container'
    "
  >
    @if (isMaxProducts && !isLastPage) {
    <div (click)="loadNextPage(model?.pagination?.currentPage + 1)" class="btn btn-block btn-action align-btn">
      {{ 'productList.showMoreBtn' | cxTranslate }}
    </div>
    }
  </div>
  @if (appendProducts) {
  <div class="cx-spinner">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
  }
</div>
}
